export { default } from '@/features/venues/VenueDetailScreen';
